var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 150,
    viewBox: "0 0 131 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2847_26456)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.36 60.6516L26.0703 76.7485L38.9857 149.995L130.276 133.898L117.36 60.6516Z",
    fill: "#FDBD15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.454 123.62L109.516 137.565L130.265 133.91L128.454 123.62Z",
    fill: "#F7E472"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7031 147.933L79.8723 142.794L125.861 108.927L123.308 94.47L50.7031 147.933Z",
    fill: "#F7E472"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707 97.5091L32.2532 111.966L97.0817 64.2319L67.9125 69.3767L29.707 97.5091Z",
    fill: "#F7E472"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8594 126.658L37.4055 141.121L120.72 79.7769L118.167 65.3137L34.8594 126.658Z",
    fill: "#F7E472"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1689 65.7976L55.2422 71.6035L68.1575 144.85L101.084 139.044L88.1689 65.7976Z",
    fill: "#0B70D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1689 65.8008L55.2422 71.6067L55.3949 72.4727L88.3216 66.6668L88.1689 65.8008Z",
    fill: "#FAFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1693 56.4879C60.1693 56.4879 80.7288 20.8548 64.6382 0L57.3672 3.16301C57.3672 3.16301 71.0954 24.5625 60.1693 56.4879Z",
    fill: "#A1D3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.185 56.4879C60.185 56.4879 42.1453 29.3661 54.3052 0.570916L64.6539 0C64.6539 0 51.011 19.7524 60.185 56.4879Z",
    fill: "#0B70D0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5156 55.3916C59.5156 55.3916 94.6827 34.0512 90.647 8.02528L82.7723 7.29688C82.7723 7.29688 84.4522 32.6665 59.5156 55.3916Z",
    fill: "#A1D3FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5075 55.3926C59.5075 55.3926 56.7448 22.9685 81.2614 3.55078L90.6389 8.02624C90.6389 8.02624 69.1475 18.7752 59.5075 55.3926Z",
    fill: "#0B70D0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8721 57.8451C57.8721 57.8451 16.7399 58.8163 6.14844 34.7L12.4088 29.8308C12.4088 29.8308 24.6146 52.1359 57.8721 57.8451Z",
    fill: "#A1D3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8721 57.8457C57.8721 57.8457 42.7396 29.0177 11.6082 25.894L6.14844 34.7006C6.14844 34.7006 30.0219 32.1938 57.8721 57.8457Z",
    fill: "#0B70D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2313 56.7499C57.2313 56.7499 21.6442 77.3948 0.75 61.35L3.89332 54.0725C3.89332 54.0725 25.3322 67.7482 57.2313 56.7499Z",
    fill: "#A1D3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2313 56.7497C57.2313 56.7497 30.0636 38.7757 1.29467 51.0012L0.75 61.3498C0.75 61.3498 20.4696 47.6675 57.2313 56.7497Z",
    fill: "#0B70D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6894 45.6537C74.4107 46.8822 74.7524 48.2966 74.6714 49.7189C74.5904 51.1412 74.0904 52.5078 73.2343 53.6465C72.3782 54.7851 71.2043 55.645 69.8604 56.1179C68.5166 56.5907 67.0629 56.6553 65.6824 56.3036C64.3019 55.9518 63.0563 55.1995 62.1025 54.1413C61.1488 53.083 60.5295 51.7663 60.3226 50.3568C60.1157 48.9472 60.3306 47.508 60.94 46.2204C61.5495 44.9327 62.5264 43.8542 63.7476 43.1206C64.5654 42.6294 65.4725 42.3051 66.4164 42.1666C67.3603 42.0281 68.3223 42.078 69.2468 42.3136C70.1713 42.5491 71.0399 42.9656 71.8025 43.5389C72.565 44.1122 73.2063 44.831 73.6894 45.6537Z",
    fill: "#B1D5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0805 59.257C53.8033 60.4855 54.1463 61.9005 54.0662 63.3236C53.986 64.7467 53.4863 66.1142 52.6301 67.2538C51.7739 68.3934 50.5995 69.2539 49.2549 69.727C47.9103 70.2001 46.4558 70.2645 45.0747 69.9121C43.6935 69.5598 42.4476 68.8064 41.494 67.747C40.5404 66.6876 39.9218 65.3696 39.7162 63.9592C39.5105 62.5487 39.727 61.1089 40.3384 59.8213C40.9499 58.5338 41.9288 57.456 43.1518 56.724C43.9691 56.2348 44.8751 55.9122 45.8177 55.7747C46.7602 55.6373 47.7206 55.6878 48.6435 55.9233C49.5665 56.1587 50.4337 56.5745 51.1952 57.1467C51.9567 57.7188 52.5975 58.4361 53.0805 59.257Z",
    fill: "#B1D5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5772 65.4375C70.6962 61.0236 71.2677 53.2956 66.8538 48.1766C62.4399 43.0576 54.712 42.4861 49.593 46.9C44.474 51.3139 43.9024 59.0419 48.3163 64.1608C52.7302 69.2798 60.4582 69.8514 65.5772 65.4375Z",
    fill: "#85BCFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1145 51.093C67.1187 52.7836 67.599 54.7341 67.4946 56.6977C67.3903 58.6613 66.706 60.5499 65.5283 62.1245C64.3505 63.6992 62.7323 64.8893 60.8782 65.5443C59.0241 66.1992 57.0174 66.2896 55.1119 65.8041C53.2064 65.3185 51.4877 64.2788 50.1732 62.8164C48.8586 61.354 48.0072 59.5347 47.7267 57.5884C47.4462 55.6421 47.7491 53.6564 48.5972 51.8823C49.4453 50.1082 50.8004 48.6254 52.4912 47.6215C54.7582 46.2756 57.4669 45.8852 60.0217 46.5362C62.5765 47.1872 64.7681 48.8263 66.1145 51.093Z",
    fill: "#A1D3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.31
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.623 61.4946L26.0469 76.7519L29.9711 99.0176L112.623 61.4946Z",
    fill: "#9FAFD2"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.646 25.1127L11.7578 79.4553L24.7322 101.394L116.62 47.0512L103.646 25.1127Z",
    fill: "#FDBD15"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1323 41.2647L39.2969 63.1089L52.2957 85.0284L89.131 63.1842L76.1323 41.2647Z",
    fill: "#0B70D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2847_26456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.506,
    height: 150,
    fill: "white",
    transform: "translate(0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/giftBox.00b5353a556b2bb76f3fa181e0335156.svg";
export { ForwardRef as ReactComponent };